export default __webpack_public_path__ + "locales/sk/ChangePortalOwner.json?hash=c041fd6ec369aceda29679958bf84349";